export const getLoading = (state) => state?.upload?.loading;
export const getUploads = (state) => state?.upload?.uploads;
